import { Typography, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { LinkedinOutlined, MediumOutlined} from '@ant-design/icons';
import {Footer, Container, Menu} from '../auxiliary/auxiliary';




function Item({ first, second }) {
  // first и second — объекты вида { text: "Blog", url: "/bugbounty", newTab: true/false, disable: true/false }

  const navigate = useNavigate();

  const handleClick = ({ url, newTab, disable }) => {
    if (disable) return; // если отключена — ничего не делаем
    if (newTab) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  return (
    <div style={{ position: "relative", height: "20vh", borderTop: "1px solid #d9d9d9" }}>
      <Container>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            height: "100%",
            alignItems: "center",
           fontSize: "clamp(1.5rem, 5vw, 3rem)"
          }}
        >
          <div>
            <span
              style={{
                position: "relative",
                zIndex: "2",
                pointerEvents: "none",
                color: first.disable ? "#bfbfbf" : "inherit", // серый текст, если disable
              }}
            >
              {first.text}
            </span>
            <span
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                width: "50vw",
                borderRight: "1px solid #d9d9d9",
                cursor: first.disable ? "not-allowed" : "pointer",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) =>
                !first.disable &&
                (e.currentTarget.style.backgroundColor = "#e6f7ff")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
              onClick={() => handleClick(first)}
            ></span>
          </div>

          <div
            style={{
              position: "relative",
              height: "100%",
              display: "grid",
              alignItems: "center",
            }}
          >
            <span
              style={{
                position: "relative",
                zIndex: "2",
                pointerEvents: "none",
                paddingLeft: "15px",
                color: second.disable ? "#bfbfbf" : "inherit", // серый текст, если disable
              }}
            >
              {second.text}
            </span>
            <span
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                width: "50vw",
                height: "100%",
                borderRight: "1px solid #d9d9d9",
                cursor: second.disable ? "not-allowed" : "pointer",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) =>
                !second.disable &&
                (e.currentTarget.style.backgroundColor = "#e6f7ff")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
              onClick={() => handleClick(second)}
            ></span>
          </div>
        </div>
      </Container>
    </div>
  );
}


function Welcome() {


    const gridItems = [
        { label: "Blog", to: "https://medium.com/@hackerhub", disabled: false },
        { label: "Labs", to: "/", disabled: true },
        { label: "Tools", to: "/", disabled: true },
        { label: "Bug Bounty", to: "/bugbounty", disabled: true }, 
       
      ];


    return (    
<div style={{fontFamily:
    "Mona Sans, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",}}>
    
    <Helmet>
        <title>HackerHub</title>
    </Helmet>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // высота страницы 100% окна
      }}
    >
        <Menu />



      {/* Основной контент — сетка */}



      <Item
  first={{ text: "Blog", url: "https://medium.com/@hackerhub", newTab: true }}
  second={{ text: "Bug Bounty", url: "/bugbounty/", newTab: false }}
/>
<Item
  first={{ text: "Labs", url: "#", newTab: true, disable: true }}
  second={{ text: "Tools", url: "#", newTab: false, disable: true }}
/>

  {/* <div style={{ position: "relative", height: "20vh", borderTop: "1px solid #d9d9d9"}}>
        <Container>
    
          <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", height: "100%", alignItems: "center", fontSize: "3rem"}}>
            <div >
              Blog
              <span style={{position: "absolute", left: "0px", top: "0px", right: "0px", bottom: 0, zIndex: "-10", width: "50vw", borderRight: "1px solid #d9d9d9"}}></span>
            </div>

            <div style={{paddingLeft:"30px"}}>
              Blog
              <span style={{position: "absolute", left: "0px", top: "0px", right: "0px", bottom: 0, zIndex: "-11", width: "100vw", borderRight: "1px solid #d9d9d9"}}></span>
            </div>
    
          </div>

        
        </Container>
  </div> */}





        {/* {gridItems.map((item, index) =>
      item.disabled ? (
        <div
          key={index}
          style={{
            border: "1px solid #f0f0f0",
            display: "flex",
            // justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f5f5f5",
            color: "#999",
            paddingLeft: "40px",
            pointerEvents: "none",
            transition: "background-color 0.3s",
          }}
        >
          <h2 style={{paddingLeft: "9vw"}}>{item.label}</h2>
        </div>
      ) : (
        <Link
          key={index}
          to={item.to}
          style={{
            border: "1px solid #f0f0f0",
            display: "flex",
            // justifyContent: "center",
            alignItems: "center",
            textDecoration: "none",
            color: "#000",
            paddingLeft: "40px",
            backgroundColor: "#fff",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e6f7ff")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
            
          <h2 style={{paddingLeft: "9vw"}}>{item.label}</h2>
        </Link>
      )
    )} */}





      {/* Футер */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "150px 150px",
          backgroundColor: "#fffff",
          borderTop: "1px solid #d9d9d9"
        }}
      > */}




        <Footer/>

    </div>
    {/* </Drawer> */}

    
  </div>
    );
}


export default Welcome;